<template>
    <textarea :name="name" class="form-control" :id="id" :rows="rows" v-model="value">{{ text }}</textarea>
</template>

<script>
    export default {
        name: 'text-area',
        props: {
            id : {
                type: String
            },
            name : {
                type: String
            },
            rows: {
                type: String
            },
            text: {
                type: String
            }
        },
        data () {
            return {
                value : ''
            };
        },
        watch: {
            value: function(val) {
                this.$emit('update',val);
            }
        }
    }
</script>